import { Component, signal } from '@angular/core';

@Component({
  selector: 'allas-floating-contact-menu',
  imports: [],
  styles: `
    @keyframes contact-menu-slide-up {
      from {
        opacity: 0;
        transform: translateY(0.75rem);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes contact-menu-slide-down {
      from {
        opacity: 1;
        transform: translateY(0);
      }
      to {
        opacity: 0;
        transform: translateY(0.75rem);
      }
    }

    .contact-menu-enter {
      animation: contact-menu-slide-up 0.3s ease-out;
    }

    .contact-menu-leave {
      animation: contact-menu-slide-down 0.25s ease-in forwards;
    }

    @media (prefers-reduced-motion: reduce) {
      .contact-menu-enter,
      .contact-menu-leave {
        animation: none;
      }
    }
  `,
  template: `
    <div
      class="fixed bottom-4 right-4 md:bottom-9 md:right-9 z-[70] flex flex-col items-end gap-3 font-sans"
    >
      @if (isOpen() || isClosing()) {
      <div
        class="w-[min(100vw-2rem,23.5rem)] rounded-2xl shadow-2xl"
        [class.contact-menu-enter]="isOpen() && !isClosing()"
        [class.contact-menu-leave]="isClosing()"
        (animationend)="onMenuAnimationEnd($event)"
        role="dialog"
        aria-label="Menú de contacto"
      >
        <!-- Header -->
        <div class="rounded-t-xl bg-appPrimary-500 px-4 pb-8 pt-5">
          <img
            src="/logos/version-white-blue.webp"
            alt="Allas Repuestos"
            class="mx-auto h-11 w-auto object-contain"
            width="176"
            height="44"
          />
        </div>

        <!-- Body (overlaps header like MessageBird) -->
        <div class="relative -mt-4 rounded-xl bg-white px-4 py-5 shadow-md">
          <h2 class="mb-4 text-base font-bold text-gray-800">
            Contáctanos por tu canal favorito
          </h2>

          <div class="flex flex-col gap-2.5">
            <a
              href="https://wa.me/50495089953?text=Hola,%20necesito%20cotizar%20un%20producto.%20¿Podrían%20ayudarme?"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center gap-3 rounded-lg border border-gray-200 px-4 py-3 text-sm font-medium text-gray-800 transition-colors hover:border-whatsappGreen hover:bg-green-50"
              aria-label="Contactar por WhatsApp"
            >
              <img
                src="/logos/third-party/whatsapp.svg"
                alt=""
                class="h-6 w-6 shrink-0"
                width="24"
                height="24"
              />
              WhatsApp
            </a>

            <a
              href="https://m.me/AllasRepuestoshn"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center gap-3 rounded-lg border border-gray-200 px-4 py-3 text-sm font-medium text-gray-800 transition-colors hover:border-[#0084FF] hover:bg-blue-50"
              aria-label="Contactar por Facebook Messenger"
            >
              <img
                src="/logos/third-party/messenger.svg"
                alt=""
                class="h-6 w-6 shrink-0"
                width="24"
                height="24"
              />
              Facebook Messenger
            </a>
          </div>

          <h2 class="mb-3 mt-5 text-base font-bold text-gray-800">
            Descarga nuestra app
          </h2>

          <div class="flex flex-col gap-2.5">
            <a
              href="https://play.google.com/store/apps/details?id=com.allasrepuestos.membresia_lealtad&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center justify-center rounded-lg border border-gray-200 px-4 py-2.5 transition-colors hover:border-gray-400 hover:bg-gray-50"
              aria-label="Descargar aplicación desde Google Play"
            >
              <img
                src="/allas-icons/google-play.svg"
                alt="Google Play"
                class="h-10 w-auto"
                height="32"
              />
            </a>

            <a
              href="https://apps.apple.com/hn/app/allas-repuestos-bater%C3%ADas/id6752626505?l=en-GB"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center justify-center rounded-lg border border-gray-200 px-4 py-2.5 transition-colors hover:border-gray-400 hover:bg-gray-50"
              aria-label="Descargar aplicación desde Apple App Store"
            >
              <img
                src="/allas-icons/app_store.svg"
                alt="App Store"
                class="h-10 w-auto"
                height="32"
              />
            </a>

            <a
              href="https://appgallery.huawei.com/#/app/C115506247"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center justify-center rounded-lg border border-gray-200 px-4 py-2.5 transition-colors hover:border-gray-400 hover:bg-gray-50"
              aria-label="Descargar aplicación desde Huawei AppGallery"
            >
              <img
                src="/allas-icons/huawei-appgallery.svg"
                alt="Huawei AppGallery"
                class="h-10 w-auto"
                height="32"
              />
            </a>
          </div>
        </div>
      </div>
      }

      <!-- Toggle button -->
      <button
        type="button"
        (click)="toggle()"
        class="flex size-16 items-center justify-center rounded-2xl bg-appPrimary-500 text-white shadow-lg transition-transform hover:scale-105 hover:bg-appPrimary-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-appPrimary-300 focus-visible:ring-offset-2"
        [attr.aria-expanded]="isOpen() || isClosing()"
        [attr.aria-label]="
          isOpen() || isClosing()
            ? 'Cerrar menú de contacto'
            : 'Abrir menú de contacto'
        "
      >
        @if (isOpen() || isClosing()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          class="size-8"
          aria-hidden="true"
        >
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
        } @else {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="size-8"
          aria-hidden="true"
        >
          <path
            d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
          />
          <path d="M7 11h10" />
          <path d="M7 15h6" />
          <path d="M7 7h8" />
        </svg>
        }
      </button>
    </div>
  `,
})
export class FloatingContactMenu {
  readonly isOpen = signal(false);
  readonly isClosing = signal(false);

  toggle(): void {
    if (this.isOpen()) {
      this.beginClose();
      return;
    }

    this.isClosing.set(false);
    this.isOpen.set(true);
  }

  onMenuAnimationEnd(event: AnimationEvent): void {
    if (event.target !== event.currentTarget || !this.isClosing()) {
      return;
    }

    this.isClosing.set(false);
  }

  private beginClose(): void {
    if (
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      this.isOpen.set(false);
      this.isClosing.set(false);
      return;
    }

    this.isClosing.set(true);
    this.isOpen.set(false);
  }
}
